import Reveal from '@/components/base/Reveal';
import { videos } from '@/mocks/results';

export default function VideoProof() {
  return (
    <section className="relative py-20 md:py-28">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <Reveal className="text-center max-w-2xl mx-auto">
          <span className="inline-flex items-center gap-2 rounded-full border border-primary-500/30 bg-primary-500/10 px-4 py-1.5 text-xs font-label font-semibold text-primary-400">
            <i className="ri-vidicon-line"></i>
            Video Testimonials
          </span>
          <h2 className="mt-6 font-heading font-bold text-3xl md:text-4xl text-foreground-950">
            Hear It Directly From the Businesses
          </h2>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {videos.map((v, i) => (
            <Reveal key={v.name} delay={i * 80}>
              <div className="rounded-2xl border border-white/8 bg-background-100 overflow-hidden group cursor-pointer">
                <div className="relative w-full aspect-video">
                  <img
                    src={v.image}
                    alt={`${v.name} — ${v.business} testimonial`}
                    title={`${v.name} — ${v.business} client testimonial`}
                    className="absolute inset-0 w-full h-full object-cover object-top"
                  />
                  <div className="absolute inset-0 bg-background-950/30 group-hover:bg-background-950/40 transition-colors" />
                  <span className="absolute inset-0 flex items-center justify-center">
                    <span className="w-14 h-14 flex items-center justify-center rounded-full bg-primary-500 text-background-950 transition-transform duration-300 group-hover:scale-110">
                      <i className="ri-play-fill text-2xl"></i>
                    </span>
                  </span>
                </div>
                <div className="p-5">
                  <p className="font-heading font-semibold text-sm text-foreground-950">{v.name}</p>
                  <p className="text-xs text-foreground-600">{v.business}</p>
                  <p className="mt-3 text-sm text-primary-400 font-label font-medium">{v.summary}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}